import { get } from "../http/functions";
import {
  setActiveSession,
  setDates
} from "./slices";
import { initializeJSONForCurrentSession } from "../storage/thunks";
import { SESSION_KINDS } from "../../util/constants";

export const getSessionInfoQueryFn = async (
  { type = SESSION_KINDS.FGC, options, year, period, ...rest },
  { dispatch }
) => {
  try {
    let path = `/session/${type}`;
    if(year || period) {
      path += `?`;
      path += [year ? `year=${year}` : '', period ? `period=${period}` : ''].filter(Boolean).join('&')
    }
    const { data, error: _error } = await get(path, {
      ...rest,
      options: {
        ...(options || {}),
        authMode: "iam",
      },
    });
    if(!data) {
      throw new Error('No session data returned from API');
    }
    if(year && period) {
      return { data };
    }
    const { reportingPeriod, datesAndDeadlines } = data;
    if (datesAndDeadlines?.length) {
      dispatch(setDates(datesAndDeadlines));
    }
    if (reportingPeriod) {
      dispatch(setActiveSession(reportingPeriod));
    }
    const paths = await dispatch(initializeJSONForCurrentSession()).unwrap();

    return data
      ? {
          data: {
            ...data,
            paths,
          },
        }
      : { error: _error };
  } catch (error) {
    return error?.error ? error : { error };
  }
};

export const getAllSessionsQueryFn = async ({ type, options, ...rest }) => {
  try {
    const { data, error: _error } = await get(`/session/${type}?all=true`, {
      ...rest,
    });

    return data
      ? {
          data,
        }
      : { error: _error };
  } catch (error) {
    return error?.error ? error : { error };
  }
};

export const getSessionSchemaQueryFn = async (
  { type, ...rest },
) => {
  let path = `/system/schema`;
  if (type) {
    path += `?type=${type}`;
  }
  try {
    const { data, error: _error } = await get(path, {
      ...rest,
    });
    if (data) {
      return {
        data
      };
    }
    return {
      error: _error,
    };
  } catch (error) {
    return error?.error ? error : { error };
  }
};
